import { useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight as iconArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { faCalendarPlus as iconCalendarPlus } from "@fortawesome/pro-duotone-svg-icons";
import { faHouseChimneyUser as iconHome } from "@fortawesome/pro-duotone-svg-icons";
import { faPeopleArrows as iconTrade } from "@fortawesome/pro-duotone-svg-icons";
import { faRoute as iconRoute } from "@fortawesome/pro-duotone-svg-icons";
import { faTimes as iconClose } from "@fortawesome/pro-thin-svg-icons";

import AboutIndex from "components/about/AboutIndex";
import imageHeroSignal from "assets/heros/map-signal-main.png";
import { scrollSnapTop } from "services/tools";

import "./HomeLanding.css";

const steps = [
  {
    icon: iconHome,
    title: "Offer a place or idea",
    text: "A spare room, table, studio, skill, game night, walk or weekly ritual.",
  },
  {
    icon: iconCalendarPlus,
    title: "Set repeat dates",
    text: "Let people choose when they can show up and trigger the next meet.",
  },
  {
    icon: iconTrade,
    title: "Build local exchange",
    text: "Turn neighbours into collaborators, customers, hosts and regulars.",
  },
];

function HomeLandingLocalEconomy(props) {
  const [showAbout, setShowAbout] = useState(false);

  const handleConnect = () => {
    props.drawerConnectToggle();
  };

  const handleToggleAbout = () => {
    scrollSnapTop();
    setShowAbout(!showAbout);
  };

  if (showAbout) {
    return (
      <Box className="home-exp home-exp-about">
        <Container maxWidth="md" disableGutters>
          <Box className="home-exp-close" onClick={handleToggleAbout}>
            <FontAwesomeIcon icon={iconClose} size="2x" />
          </Box>
          <AboutIndex {...props} />
        </Container>
      </Box>
    );
  }

  return (
    <Box className="home-exp home-exp-local">
      <Box className="home-exp-localHero">
        <Container maxWidth="lg" className="home-exp-localHeroInner">
          <Box className="home-exp-localCopy">
            <Box className="home-exp-kicker">
              <FontAwesomeIcon icon={iconRoute} />
              <span>For hosts, rooms and repeat meets</span>
            </Box>
            <Typography variant="h1" className="home-exp-title">
              Run your local life from one signal
            </Typography>
            <Typography variant="h5" className="home-exp-subtitle">
              Create a small gathering, invite nearby people, take payments when
              needed, and make it easy to happen again.
            </Typography>
            <Stack
              className="home-exp-actions"
              direction={{ xs: "column", sm: "row" }}
              spacing={1.5}
            >
              <Button
                variant="contained"
                size="large"
                className="home-exp-primary"
                onClick={handleConnect}
                endIcon={<FontAwesomeIcon icon={iconArrowRight} />}
              >
                Start hosting
              </Button>
              <Button
                variant="outlined"
                size="large"
                className="home-exp-secondary"
                onClick={handleToggleAbout}
              >
                See the idea
              </Button>
            </Stack>
          </Box>
          <Box
            className="home-exp-device"
            sx={{
              backgroundImage: `url(${imageHeroSignal})`,
            }}
          />
        </Container>
      </Box>

      <Container maxWidth="lg" className="home-exp-section">
        <Box className="home-exp-steps">
          {steps.map((step) => (
            <Box className="home-exp-step" key={step.title}>
              <FontAwesomeIcon icon={step.icon} />
              <Typography variant="h6">{step.title}</Typography>
              <Typography variant="body2">{step.text}</Typography>
            </Box>
          ))}
        </Box>
      </Container>

      <Container maxWidth="md" className="home-exp-copyBand">
        <Typography variant="h4">The signup promise is concrete.</Typography>
        <Typography variant="body1">
          Entzy is for people who want to create things locally: supper clubs,
          music rooms, parent groups, sports plans, workshops, skill swaps,
          venue offers and neighbourhood experiments.
        </Typography>
        <Typography variant="body1">
          Instead of asking people to follow another feed, ask them to join a
          signal they can actually show up for.
        </Typography>
      </Container>
    </Box>
  );
}

export default HomeLandingLocalEconomy;
